import { render } from "./PatrolNumber.vue?vue&type=template&id=5bc8ad5a&scoped=true"
import script from "./PatrolNumber.vue?vue&type=script&lang=js"
export * from "./PatrolNumber.vue?vue&type=script&lang=js"

import "./PatrolNumber.vue?vue&type=style&index=0&id=5bc8ad5a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc8ad5a"]])

export default __exports__